import MicIcon from '@/assets/icons/mic.svg?react'
import { Text } from '@/ui-kit'

type RecordingStateIdleProps = {
  onStartRecording: () => void
}

export const RecordingStateIdle = ({ onStartRecording }: RecordingStateIdleProps) => (
  <div className="flex flex-col items-center gap-2" style={{ animation: 'nectar-scale-in 0.35s ease-out' }}>
    <div className="relative flex items-center justify-center" style={{ width: 96, height: 96 }}>
      <div
        className="bg-red absolute inset-0 rounded-full"
        style={{ animation: 'nectar-pulse-ring 2s ease-out infinite' }}
      />
      <div
        className="bg-red absolute inset-0 rounded-full opacity-0"
        style={{ animation: 'nectar-pulse-ring 2s ease-out infinite 0.8s' }}
      />
      <button
        type="button"
        onClick={onStartRecording}
        className="bg-red relative z-10 flex size-20 items-center justify-center rounded-full text-white shadow-lg transition-all duration-200 hover:scale-105"
      >
        <MicIcon className="h-12" />
      </button>
    </div>

    <Text type="body2-regular" className="text-gray-90">
      Tap to start recording
    </Text>
  </div>
)
